import PropTypes from 'prop-types'
import classNames from 'classnames'

import classes from './Drawer.module.scss'

const DrawerFacts = ({ facts }) => (
  <div className={classes.facts}>
    {facts.map(fact => (
      <div key={fact.label}>
        <span className={classNames(classes.factLabel, 'd-block mb-1')}>{fact.label}</span>
        <div className={classes.factValue}>{fact.value}</div>
      </div>
    ))}
  </div>
)

DrawerFacts.propTypes = {
  facts: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
    value: PropTypes.node,
  })).isRequired,
}

export default DrawerFacts
